import { styled } from '@mui/material/styles';
import { Box, Button, Grid, Typography } from '@mui/material';
import { BackgroundCoca } from '../../assets/images';

export const LoginPageContainer = styled(Grid)(() => ({
  height: '100%',
  width: '100%',
  backgroundColor: '#f4f6fa',
  backgroundImage: `url(${BackgroundCoca})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  position: 'relative',
}));

export const RightPanel = styled(Grid)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}));

export const HeaderLogoContainer = styled(Box)(() => ({
  position: 'absolute',
  top: 0,
  right: 0,
}));

export const LoginBackgroundImage = styled('img')({
  zIndex: 0,
});

export const CocacolaTagImage = styled('img')({
  position: 'absolute',
  zIndex: 1,
  right: '2%',
  top: '5%',
  background: 'white',
});

export const LoginSection = styled(Box)(() => ({
  position: 'absolute',
  bottom: '10%',
  right: '4%',
  width: '552px',
  height: '432px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignContent: 'center',
  alignItems: 'center',
  backgroundColor: '#ffffff',
  border: `1px solid #ddd`,
  borderRadius: '27px',
}));

export const FooterContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  marginBottom: '5%',
  marginRight: '10%',
}));

export const CommonButton = styled(Button)(() => ({
  backgroundColor: '#E3212C',
  color: '#fff',
  width: '400px',
  height: '80px',
  '&:hover': {
    backgroundColor: '#E3212C',
  },
  borderRadius: '7px',
}));

export const LoginTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  color: '#000',

  fontWeight: 700,
  fontSize: 35,
  lineHeight: '29.26px',
  letterSpacing: '-3%',
}));

export const LoginSubtitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  color: '#000',

  fontSize: 17,
  fontWeight: 500,
  lineHeight: '19.5px',
}));

export const LoginSmallText = styled(Typography)(() => ({
  color: '#000',

  fontSize: 14,
  fontWeight: 700,
  lineHeight: '13.91px',
  letterSpacing: '2%',
}));

export const LeftPanelImage = styled('img')({
  width: 'auto',
});

export const InfoImage = styled('img')({
  marginRight: '7px',
  color: 'black',
});

export const CenteredGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: theme.spacing(1),
}));
